import '../pages/css/themes/AccountingBox.css';
import './app.scss';
import './atlaskit-reset.scss'
import './overrides.scss'

const cache = {};
function importAll (r) {
    r.keys().forEach(key => cache[key] = r(key));
}

importAll(
    require.context("./", true, /.*(?!app)\.(less|css|scss)$/)
);
